export const Marquee = ({ t }) => {
  const items = t.marquee.repeat(4);
  return (
    <div
      className="border-y border-line bg-cream py-6 md:py-8 overflow-hidden select-none"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <span
            key={half}
            className="font-heading italic font-light text-4xl md:text-6xl lg:text-7xl text-ink/85 pr-2"
          >
            {items}
          </span>
        ))}
      </div>
    </div>
  );
};
